//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import therapeuten from '~/graphql/queries/therapeuten.gql';

export default {
  auth: false,
  apollo: {
    therapeuten: {
      query: therapeuten,
      throttle: 500,
      debounce: 100,
      deep: true,
      variables() {
        return this.queryVariables;
      },
      result({data}, key) {
        if (data[key].current_page !== this.requested_page) {
          this.requested_page = data[key].last_page >= this.requested_page ? this.requested_page : data[key].current_page;
        }
        if (data[key].per_page !== this.show_per_page) {
          this.show_per_page = data[key].per_page;
        }
      },
    },
  },
  data: () => ({
    therapeuten: {
      data: [],
      total: 0,
      per_page: 9,
      current_page: 1,
    },
    show_per_page: 9,
    search: {
      hoofdrichting: null,
      distance: null,
      city: null,
      query: null,
      name: null,
    },
    requested_page: 1,
  }),
  computed: {
    valuesPerPage() {
      const values = {};
      for (let i = 3; i < 30; i += 3) {
        values[i] = i.toString(10);
      }
      return values;
    },
    totalPages() {
      return this.therapeuten ? Math.ceil(this.therapeuten.total / this.therapeuten.per_page) : 0;
    },
    queryVariables() {
      const afstand = this.search.distance ? Number.parseInt(this.search.distance) : 0;

      return {
        hoofdrichting: this.search.hoofdrichting && this.search.hoofdrichting > 0 ? this.search.hoofdrichting : null,
        plaats: this.search.city && this.search.city.length > 0 ? this.search.city : null,
        query: this.search.query && this.search.query.length > 0 ? this.search.query : null,
        name: this.search.name && this.search.name.length > 0 ? this.search.name : null,
        afstand: afstand > 0 ? afstand : null,
        limit: Number.parseInt(this.show_per_page, 10),
        page: this.therapeuten ? Math.max(1, Math.min(this.requested_page, Math.ceil(this.therapeuten.total / this.show_per_page))) : 1,
      };
    },
  },
  watch: {
    search: {
      deep: true,
      handler() {
        this.updateRouteQuery();
      },
    },
    requested_page: {
      deep: true,
      handler() {
        this.updateRouteQuery();
      },
    },
  },
  mounted() {
    this.search = {
      hoofdrichting: this.$route.query.hoofdrichting ?? null,
      distance: this.$route.query.distance ?? null,
      city: this.$route.query.city ?? null,
      query: this.$route.query.query ?? null,
      name: this.$route.query.name ?? null,
    };

    this.requested_page = this.$route.query.page ?? 1;
  },
  methods: {
    updateRouteQuery() {
      try {
        this.$router.replace({
          name: 'therapeut-vinden',
          query: {
            ...this.search,
            page: this.requested_page,
          },
        });
      } catch (e) {
      }
    },
  },
  head: () => ({
    title: 'Zorgverlener vinden',
  }),
};
